import PropTypes from 'prop-types'

const FixedIndexIcon = ({ title }: any) => (
  <svg width="191px" height="191px" viewBox="0 0 191 191">
    <title>{title}</title>
    <g id="layout-options-explorations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="tooltip-future" transform="translate(-39.000000, -122.000000)">
        <g id="Fixed-Image" transform="translate(39.000000, 122.000000)">
          <g id="visual_fixedwidth">
            <rect id="Rectangle" fill="#D8D8D8" x="0" y="0" width="191" height="191"></rect>
            <rect id="Rectangle" fill="#9F9F9F" x="0" y="16" width="14" height="175"></rect>
            <rect id="Rectangle-Copy" fill="#828282" x="14" y="16" width="62" height="175"></rect>
            <rect id="Rectangle-Copy-2" fill="#806BF2" x="76" y="16" width="62" height="175"></rect>
            <rect id="Rectangle" fill="#FFFFFF" x="20" y="4" width="105" height="6" rx="1.5"></rect>
            <circle id="Oval-Copy" fill="#8D8D8D" cx="5" cy="7" r="3"></circle>
            <circle id="Oval-Copy-2" fill="#8D8D8D" cx="13" cy="7" r="3"></circle>
            <line
              x1="79"
              y1="63.1666667"
              x2="79"
              y2="74.8333333"
              id="Line-2"
              stroke="#FFFFFF"
              strokeLinecap="square"
            ></line>
            <line
              x1="135"
              y1="63.1666667"
              x2="135"
              y2="74.8333333"
              id="Line-2-Copy"
              stroke="#FFFFFF"
              strokeLinecap="square"
            ></line>
            <line
              x1="133.066667"
              y1="69"
              x2="78.9333333"
              y2="69"
              id="Line-3"
              stroke="#FFFFFF"
              strokeLinecap="square"
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
FixedIndexIcon.displayName = 'FixedIndexIcon'

FixedIndexIcon.propTypes = {
  title: PropTypes.string
}

FixedIndexIcon.defaultProps = {
  title: 'Fixed Width'
}
export default FixedIndexIcon
